import { Injectable } from '@angular/core';
import { PointStoreProductEditService } from '../../marketplace/admin/services/point-store-product-edit.service';
import { PointStoreNavigationBarService } from '../../marketplace/admin/services/point-store-navigation-bar.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Injectable({
  providedIn: 'root'
})
export class CvPointStoreProductService {

  pointStoreProductValidationMessages: any = [
    { name: "Leave", keyLocalization: "Validate_Leave_Product_Title" },
    { name: "All changes will be lost", keyLocalization: "Validate_Leave_Product_Description" },
    { name: "Stay", keyLocalization: "Validate_Leave_Product_Stay_Button" },
    { name: "Leave", keyLocalization: "Validate_Leave_Product_Leave_Button" },
  ];

  teams: any = {};

  constructor(private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreNavigationBarService: PointStoreNavigationBarService,
    private cvLocalizationService: CVLocalizationService,
    private dialogService: CvCustomDialogService) { }

  async loadMessages() {
    try {
      let response = await this.cvLocalizationService.GetSection("MarketPlace_Management_Messages");
      for (let i = 0; i < this.pointStoreProductValidationMessages.length; i++) {
        this.pointStoreProductValidationMessages[i].name = response.get(this.pointStoreProductValidationMessages[i].keyLocalization)
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  validatePointStoreProductCancelButton(isDirty: boolean = true) {
    if (!isDirty) {
        this.pointStoreProductEditService.copyOriginalToModified();
        this.pointStoreNavigationBarService.setSelectedFrame(0); /*LandingPage*/
        this.pointStoreProductEditService.sortPointStoreProductCollection(); //sort products on cancel
        this.pointStoreProductEditService.resetAddEditUploader(); //Reset the uploader to work (only matters if the user selects the same image, but better safe than sorry!)
        return;
    }

    this.dialogService.showDialog(
      this.pointStoreProductValidationMessages[0].name + '?',
      this.pointStoreProductValidationMessages[1].name + '.',
      4,
      this.pointStoreProductValidationMessages[2].name,
      this.pointStoreProductValidationMessages[3].name,
      true,
      () => {
        this.pointStoreProductEditService.copyOriginalToModified();
        this.pointStoreNavigationBarService.setSelectedFrame(0); /*LandingPage*/
        this.pointStoreProductEditService.sortPointStoreProductCollection(); //sort products on cancel
        this.pointStoreProductEditService.resetAddEditUploader(); //Reset the uploader to work (only matters if the user selects the same image, but better safe than sorry!)
      },
      () => { },
      'cxone-point-store-leave-modal'
    );
  }

  setTeams(teams: object){
    this.teams = teams;
  }
  
  getTeams(){
    return this.teams;
  }
}
